var map = {
	"./AUS-shield-logo.svg": "3fWG",
	"./ENG-shield-logo.svg": "B1lf",
	"./WI-shield-logo.svg": "6Bvo",
	"./codesports.svg": "sd/s",
	"./logo-AUS.svg": "EEHJ",
	"./logo-WI.svg": "1ef7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 1